import React from 'react';
import { useParams } from 'react-router-dom';
import { getModule } from '../../../../../services/DBService/DbService';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import { setModuleModifiers } from '../../../../../store/moduleStateSlice';
import { InputModifiersElement, InputSelectElement, SelectOption } from '@app/common';
import InputSelect from '../InputSelect/InputSelect';

type Properties = {
    data: InputModifiersElement
};

const InputModifier = (props: Properties) => {
    const { moduleId } = useParams();
    const dispatch = useAppDispatch();
    const moduleState = useAppSelector(state => state.moduleState.currentModuleState);
    const [allModifiers, setAllModifiers] = React.useState<SelectOption[]>([]);

    const [selectedModifiers, setSelectedModifiers] = React.useState<SelectOption[]>([]);

    React.useEffect(() => {
        const fetchModule = async () => {
            const module = await getModule(moduleId as `module_${string}`);

            setAllModifiers(module.modifiers);
            setSelectedModifiers(moduleState.modifiers.map(modifierValue => (
                {
                    value: modifierValue,
                    label: module.modifiers.find(m => m.value === modifierValue)?.label || modifierValue
                }))
            );
        };
        fetchModule();
    }, [moduleId]);

    const handleModifierChange = (options: SelectOption[]) => {
        setSelectedModifiers(options);
        dispatch(setModuleModifiers(options.map(modifier => modifier.value)));
    };

    const data: InputSelectElement = {
        type: 'input_select',
        options: allModifiers,
        label: props.data.label,
        multiselect: true,
    };

    return (
        <InputSelect
            data={data}
            value={selectedModifiers}
            setValue={handleModifierChange}
        />
    );
};
export default InputModifier;
